import { __decorate, __metadata } from "tslib";
import { Serialize } from '@ftr/serialization';
import { LocalTime } from '@js-joda/core';
/**
 * @deprecated Use LocalTimeRange instead
 */
export class TimeframeWithLocalTimes {
    constructor(start, end) {
        this.start = start;
        this.end = end;
    }
}
__decorate([
    Serialize(() => LocalTime),
    __metadata("design:type", LocalTime)
], TimeframeWithLocalTimes.prototype, "start", void 0);
__decorate([
    Serialize(() => LocalTime),
    __metadata("design:type", LocalTime)
], TimeframeWithLocalTimes.prototype, "end", void 0);
export function timecodeToTimeframeWithLocalTimes(timecode) {
    return new TimeframeWithLocalTimes(timecode.start.toLocalTime(), timecode.end.toLocalTime());
}
